import React from 'react';
import { Box } from '@mui/material';

const publicUrl = process.env.PUBLIC_URL || '';

const LOGO_PATHS = {
  full: `${publicUrl}/NewestLogo.png`,
  icon: `${publicUrl}/NewestCircleLogo.png`,
  white: `${publicUrl}/White%20Logo.png`,
};

/**
 * @param {'full' | 'icon' | 'white'} variant — full wordmark, circle icon, or white icon
 * @param {number} height — rendered height in px
 */
const HarmonateLogo = ({ variant = 'icon', height = 32, sx = {} }) => {
  const src = LOGO_PATHS[variant] || LOGO_PATHS.icon;
  const isFull = variant === 'full';

  return (
    <Box
      component="img"
      src={src}
      alt="Harmonate"
      sx={{
        height: isFull ? 'auto' : height,
        width: isFull ? '100%' : height,
        maxHeight: isFull ? height * 1.15 : height,
        maxWidth: isFull ? '100%' : height,
        objectFit: 'contain',
        flexShrink: 0,
        display: 'block',
        ...sx,
      }}
    />
  );
};

export default HarmonateLogo;
